import React, { useState, useEffect } from 'react';
import './AnalysisStep.css';
import { NamedGrayIcon } from '../../../components/icons/GrayIconBox';

const AnalysisStep = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [currentFact, setCurrentFact] = useState(0);

  const analysisSteps = [
    { id: 1, text: "설문 응답 분석 중", status: "completed" },
    { id: 2, text: "학생 성향 분류", status: "active" },
    { id: 3, text: "개인화 요소 추출", status: "pending" },
    { id: 4, text: "AI 생기부 생성 준비", status: "pending" }
  ];

  const funFacts = [
    "학생의 학습 스타일은 성적보다 학습 태도에 더 큰 영향을 미칩니다",
    "친구들과 잘 어울리는 학생은 협동심이 평균 30% 더 높습니다",
    "조용한 학생과 활발한 학생이 짝이 되면 서로 좋은 영향을 주고받아요",
    "학생들의 진심은 작은 행동에서 가장 잘 드러납니다"
  ];

  useEffect(() => {
    // 단계별 진행 시뮬레이션
    const stepInterval = setInterval(() => {
      setCurrentStep(prev => {
        if (prev < analysisSteps.length - 1) {
          return prev + 1;
        }
        return prev;
      });
    }, 800);

    // 재미있는 팩트 순환
    const factInterval = setInterval(() => {
      setCurrentFact(prev => (prev + 1) % funFacts.length);
    }, 3000);

    return () => {
      clearInterval(stepInterval);
      clearInterval(factInterval);
    };
  }, [analysisSteps.length, funFacts.length]);

  const getStepStatus = (index) => {
    if (index < currentStep) return "completed";
    if (index === currentStep) return "active";
    return "pending";
  };

  return (
    <div className="student-profile-event-analysis-step">
      <div className="student-profile-event-analysis-container">
        {/* 분석 아이콘 */}
        <div className="student-profile-event-analysis-icon">
          <div className="student-profile-event-dolphin-analyzing">
            <NamedGrayIcon name="search" boxSize={48} />
          </div>
        </div>

        {/* 제목과 설명 */}
        <h1 className="student-profile-event-analysis-title">
          왓퀴즈AI가 학생의 유형을<br/>
          <span className="student-profile-event-highlight">분석하고 있어요</span>
        </h1>
        
        <p className="student-profile-event-analysis-subtitle">
          7가지 설문 응답을 바탕으로 나만의 독특한 학생 성향을<br/>
          12가지 학생 유형 중에서 찾아내고 있어요.
        </p>

        {/* 분석 단계 */}
        <div className="student-profile-event-analysis-steps">
          <h3 className="student-profile-event-analysis-steps-title">
            분석 진행 상황
          </h3>
          <div className="student-profile-event-steps-list">
            {analysisSteps.map((step, index) => (
              <div 
                key={step.id}
                className={`student-profile-event-step-item ${getStepStatus(index)}`}
              >
                <div className="student-profile-event-step-icon">
                  {getStepStatus(index) === "completed" ? "✓" : step.id}
                </div>
                <div className="student-profile-event-step-text">
                  {step.text}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 로딩 인디케이터 */}
        <div className="student-profile-event-loading-indicator">
          <div className="student-profile-event-loading-dot"></div>
          <div className="student-profile-event-loading-dot"></div>
          <div className="student-profile-event-loading-dot"></div>
        </div>

        {/* 대기 메시지 */}
        <div className="student-profile-event-waiting-message">
          <div className="student-profile-event-waiting-title">
            <NamedGrayIcon name="clock" boxSize={40} />
            <span>잠시만 기다려주세요</span>
          </div>
          <p className="student-profile-event-waiting-description">
            정확한 분석을 위해 왓퀴즈AI가 신중하게 검토하고 있어요.<br/>
            곧 결과를 보여 드릴게요.
          </p>
        </div>

        {/* 재미있는 팩트 */}
        <div className="student-profile-event-fun-facts">
          <div className="student-profile-event-fun-facts-title">
            알고 계셨나요?
          </div>
          <div className="student-profile-event-fact-item">
            {funFacts[currentFact]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisStep;
